<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view class="view" v-if="isRouterAlive"></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
        transitionName: '',
        isRouterAlive: true,
      }
    },
    //刷新路由
    provide() {
      return {
        reload: this.reload
      }
    },
    watch: {
      $route: function (to, from) {
        window.scrollTo(0, 0)
        //将不想有过渡动画效果的部分路由写进判断条件中
        if (to.path !== '/' && to.path !== '/' && to.path !== '/' || from.path !== '/' && from.path !== '/' && from.path !== '/') {
          //如果to索引大于from索引,判断为前进状态,反之则为后退状态
          // if(to.meta.index < from.meta.index){
          //   //设置动画名称
          //   this.transitionName = 'slide-left';
          // }else if(to.meta.index > from.meta.index){
          //   this.transitionName = 'slide-right';
          // }else if(to.meta.index == 99){
          //   this.transitionName =""
          // }
          this.transitionName = 'slide-left'
          console.log('App this.transitionName', this.transitionName)
        } else {
          this.transitionName = ''
        }
      },
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(() => (this.isRouterAlive = true))
      },
    }
  }
  document.onkeydown = document.onkeyup = document.onkeypress = function (event) {
    var e = event || window.event

    if (e && e.keyCode == 123) {
      e.returnValue = false;
      return (false);
    }
  }

</script>

<style scoped="scoped" lang="scss">
  .view {
    width: 100%;
    position: absolute;
  }

  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    will-change: transform;
    transition: all 250ms;
    position: absolute;
  }

  .slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
</style>
